// Local storage helpers for persisting the New Podcast wizard state

export type NewPodcastWizardStep = 'choose' | 'style' | 'url' | 'youtube' | 'prompt' | 'document'
export type NewPodcastWizardSource = 'url' | 'youtube' | 'document' | 'prompt' | null
export type NewPodcastWizardStyle = 'educational' | 'conversational' | 'narrative' | 'deep dive' | null

export type NewPodcastWizardDraft = {
  step: NewPodcastWizardStep
  selectedSource: NewPodcastWizardSource
  style: NewPodcastWizardStyle
  durationMinutes: number
  url: string
  ytUrl: string
  prompt: string
  // If a remote document URL is selected (e.g., from signup), persist it
  fileUrl?: string | null
  languageIso: string
  additionalInstructions: string
  isPublic: boolean
  // Control flags
  resumeAfterBilling?: boolean
  timestamp: number
}

const STORAGE_KEY = 'pg:new_podcast_wizard_draft'

export const getNewPodcastDraft = (): NewPodcastWizardDraft | null => {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as NewPodcastWizardDraft
    return parsed
  } catch {
    return null
  }
}

export const setNewPodcastDraft = (draft: NewPodcastWizardDraft): void => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
  } catch {
    // best-effort only
  }
}

export const clearNewPodcastDraft = (): void => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(STORAGE_KEY)
  } catch {
    // noop
  }
}
